<template>
  <button
    class="IconButton"
    :class="{ 'is-disabled': disabled }"
    type="button"
    :disabled="disabled"
    :aria-label="ariaLabel"
  >
    <Icon
      :icon="icon"
      :size="size"
      :color="!disabled ? color : undefined"
    />
  </button>
</template>

<script setup lang="ts">
import Icon from '../Icon/Icon.vue';
import type { IconButtonProps } from './IconButton.model';

withDefaults(defineProps<IconButtonProps>(), {
  disabled: false,
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;

/* Available css custom properties::after
 * --icon-button-hover-background: sets the background color on hover state
 * --icon-button-disabled-color: sets the icon color when disabled
 */

@layer cvo-ui {
  .IconButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: fit-content;
    border-radius: vars.$border-radius-sm;
    transition: background-color 0.2s ease;
    color: inherit;

    &:hover:not([disabled]) {
      background-color: var(--icon-button-hover-background, vars.$color-neutral-gray-100);
    }

    &:focus-visible {
      outline: 2px solid vars.$color-neutral-gray-800;
      outline-offset: 2px;
    }

    &[disabled] {
      color: var(--icon-button-disabled-color, vars.$color-neutral-gray-500);
      cursor: not-allowed;
    }
  }
}
</style>
